import { Injectable, inject } from '@angular/core';
import { HotToastService, ToastOptions } from '@ngxpert/hot-toast';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private toast = inject(HotToastService);

  success(message: string, options?: ToastOptions<unknown>) {
    return this.toast.success(message, options);
  }

  error(message: string, options?: ToastOptions<unknown>) {
    return this.toast.error(message, options);
  }

  info(message: string, options?: ToastOptions<unknown>) {
    return this.toast.info(message, options);
  }

  warning(message: string, options?: ToastOptions<unknown>) {
    return this.toast.warning(message, options);
  }

  loading(message: string, options?: ToastOptions<unknown>) {
    return this.toast.loading(message, options);
  }

  observe<T>(
    messages: { loading: string; success: string; error: string },
    options?: ToastOptions<unknown>,
  ) {
    return this.toast.observe<T>({
      loading: messages.loading,
      success: messages.success,
      error: messages.error,
      ...options,
    });
  }

  show(message: string, options?: ToastOptions<unknown>) {
    return this.toast.show(message, options);
  }
}
